import MaintenancePage from "features/maintenance/pages/MaintenancePage";

import employeePositionResource from "features/maintenance/resources/employeePositionResource";

export default function EmployeePositions() {
    return <MaintenancePage resource={employeePositionResource} />;
}
